import { render, staticRenderFns } from "./TranslatorPriceForm.vue?vue&type=template&id=957d05d2&"
import script from "./TranslatorPriceForm.vue?vue&type=script&lang=js&"
export * from "./TranslatorPriceForm.vue?vue&type=script&lang=js&"
import style0 from "./TranslatorPriceForm.vue?vue&type=style&index=0&id=957d05d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports